<template>
  <div class="agent-attachments" v-if="attachments.length">
    <div v-for="asset in attachments" :key="asset.assetId || asset.name" class="attachment"
      :class="{ 'is-deleted': asset.status === 'deleted' }">
      <a v-if="asset.isImage && asset.url" :href="asset.url" target="_blank" rel="noopener noreferrer" class="image-link">
        <img :src="asset.url" :alt="asset.name">
      </a>
      <i v-else :class="asset.isImage ? 'el-icon-picture-outline' : 'el-icon-document'"></i>
      <div class="attachment-info">
        <div class="attachment-name">{{ asset.name }}</div>
        <div class="attachment-meta">
          {{ asset.status === 'deleted' ? '附件已删除' : formatAssetSize(asset.size) }}
        </div>
      </div>
      <el-button v-if="removable" type="text" class="remove-button" @click="$emit('remove', asset)">
        <i class="el-icon-close"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { formatAssetSize } from '@/utils/agent-asset.mjs'

export default {
  name: 'AgentAttachmentList',
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatAssetSize
  }
}
</script>

<style lang="scss" scoped>
.agent-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.attachment {
  display: flex;
  align-items: center;
  min-width: 180px;
  max-width: 260px;
  padding: 7px 9px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.attachment > i {
  margin-right: 7px;
  color: #7848f1;
  font-size: 20px;
}

.image-link {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-right: 7px;
}

.image-link img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.attachment-info {
  min-width: 0;
  flex: 1;
}

.attachment-name {
  overflow: hidden;
  color: #303133;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-meta {
  margin-top: 2px;
  color: #909399;
  font-size: 11px;
}

.remove-button {
  margin-left: 5px;
  padding: 2px;
}

.is-deleted {
  opacity: 0.65;
}
</style>
